theme.account = {

    resetPassword: function() {
        $('[data-reset-form]').removeClass('hidden')
        $('[data-form-title]').text('Reset Password')
        $('[data-signin-form]').addClass('hidden')
    }

}

$(function() {
    
    if ($('[data-reset-form]').find('.errors, .success').length > 0) {
        theme.account.resetPassword()
    }

    // The form
    var $newAddressForm = $('#AddressNewForm')
        
    // Toggle new/edit address forms
    let $newAddressToggle = $('#AddressNewButton')
    $newAddressToggle.on('click', function() {
        $newAddressForm.slideDown();
    })

    // Toggle edit
    let $editAddressToggle = $('[data-toggle-address]')
    $editAddressToggle.on('click', function() {
        $newAddressForm.slideUp();
        var formId = $(this).data('form-id')
        if ($(this).data('toggle-address') != 'cancel') {
            $('#EditAddress_' + formId).slideDown()
        } else {
            $('#EditAddress_' + formId).slideUp()
        }
    })
    
    // Delete an address
    let $addressDeleteToggle = $('[data-delete-address]')
    $addressDeleteToggle.on('click', function() {
        var $el = $(this)
        var formId = $el.data('form-id')
        var confirmMessage = $el.data('confirm-message')
        // eslint-disable-next-line no-alert
        if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            Shopify.postLink('/account/addresses/' + formId, {
                parameters: {
                    _method: 'delete'
                }
            })
        }
    })

})

